"use strict";
// packages/types/src/api/hazard.ts
Object.defineProperty(exports, "__esModule", { value: true });
